<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="111"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <el-button :disabled="!selectedJob || total <= 0" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <el-button type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
          <el-button :disabled="!selectedJob" type="primary" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
          <!--审核通过-->
          <el-button v-show="$checkPermission(['button_reVerify_accept'])" type="primary" @click="acceptHandler(0)">{{ $t('SeaExport.PassAudit') }}</el-button>
          <!--拒绝-->
          <el-button v-show="$checkPermission(['button_reVerify_reject'])" type="primary" @click="rejectHandler(0)">{{ $t('SeaExport.Refuse') }}</el-button>
          <!--复核通过-->
          <el-button v-show="$checkPermission(['button_reVerify_reviewThrough']) && btn.pretrialReviewConfig" type="primary" @click="btVerifyReviewThroughHandler(0)">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
          <!--复核拒绝-->
          <el-button v-show="$checkPermission(['button_reVerify_reviewRefusal']) && btn.pretrialReviewConfig" :disabled="!btn.btVerifyReviewRefusal" type="primary" @click="btVerifyReviewRefusalHandler(0)">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
          <!--编辑-->
          <el-button :disabled="!$checkPermission(['button_reVerify_accept'])" type="success" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid-wrapper
          config-module="130101"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          style="width: 100%;"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="130101"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="selectedRowCount"
          @pagination="toQuery()"
        />
      </div>
    </div>
    <!--    订舱审核-通过   -->
    <op-verify-frame-dialog
      v-if="opVerifyFrameDialog.visible"
      :visible.sync="opVerifyFrameDialog.visible"
      :job-model="opVerifyFrameDialog.job || {}"
      :batch-pass-audit="opVerifyFrameDialog.batchPassAudit"
      :submit-call-back="opVerifyFrameDialog.submitCallBack"
      :job-list="opVerifyFrameDialog.jobList"
    />
    <!--    订舱审核-拒绝   -->
    <op-verify-frame-reject
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :job-list="rejectWindow.jobList"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!--信控验证弹框-->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!--编辑-->
    <edit-dialog :visible.sync="editDialog.visible" :job-model="editDialog.job" :context="context" @reloadFunc="reloadFunc" />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      lob="RE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :new-job="batchCheckingWindow.newJob"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { DocumentManage, stopBubble, stringToBool } from '@/utils/commonUtil'
import jobDetailIcon from '@/assets/job-detail.png'
import { approved, preVerifyReject, advancedQuery, batchPreVerifyReject } from '@/api/railwayExport/reBooking'
import { batchCheckJobsCredit } from '@/api/booking/job'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import CargoFormDialog from '@/components/Cargo/Common/CargoFormDialog'
import OpVerifyFrameDialog from '@/views/cargo/v0/RailwayExport/components/verify/OpVerifyFrameDialog'
import ConfirmDialogWindow from '@/views/cargo/v0/RailwayExport/components/verify/ConfirmDialogWindow'
import OpVerifyFrameReject from '@/views/cargo/v0/RailwayExport/components/verify/OpVerifyFrameReject'
import EditDialog from '@/views/cargo/v0/RailwayExport/components/verify/EditDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { getCacheListByKey, getFilterCacheList, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RailwayExportConstants from '@/class/cargo/model/parameters/RailwayExportConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'

export default {
  name: 'VerifyTreeGrid',
  components: {
    cargoAgGridWrapper,
    EditDialog,
    OpVerifyFrameDialog,
    OpVerifyFrameReject,
    ConfirmDialogWindow,
    CargoFormDialog,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    BatchCheckingWindow,
    cooperationVerifyDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    useOrderCenterMode: { type: Boolean, default: false },
    orderCenterBranch: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      notRefresh: false,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      isEditing: false,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      total: 0,
      pageCount: 0,
      selectedJob: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}</span>`
            }
          }
        },
        // 选中、勾选框或者其他列，都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          if (this.rowDataBeforeSort.length !== this.rowData.length) {
            this.rowDataBeforeSort = this.rowData
          }
          if (!event.api.getSortModel().length) {
            this.rowData = this.rowDataBeforeSort
            this.rowDataBeforeSort = []
          } else {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        context: {
          componentParent: this
        },
        onSelectionChanged: (event) => {
          this.selectedRowCount = event.api.getSelectedRows().length
        }
      },
      selectedRowCount: 0,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          valueGetter: params => {
            if (params.data && params.data.customerId > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.data.customerTypeId, 'chineseName')
            }
            return ''
          },
          enableRowGroup: true,
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.departureStation'),
          colId: 'departureStation',
          field: 'departureStation',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.transferStation'),
          colId: 'transferStation',
          field: 'transferStation',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.transitStation'),
          colId: 'transitStation',
          field: 'transitStation',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.destinationStation'),
          colId: 'destinationStation',
          field: 'destinationStation',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: 'crossTenantHistoryState',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.data.crossTenantHistoryState)
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          enableRowGroup: true,
          hide: true,
          width: 120
        }, {
          headerName: this.$t('RailwayExport.ETD2'),
          colId: 'etd',
          field: 'etd',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.ETA2'),
          colId: 'eta',
          field: 'eta',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SequenceNumber'),
          colId: 'jobNo5',
          field: 'jobNo5',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.vessel'),
          colId: 'vessel',
          field: 'vessel',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.voyageFlight'),
          colId: 'voyageFlight',
          field: 'voyageFlight',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.mbl'),
          colId: 'mbl',
          field: 'mbl',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          colId: 'customerRefNo',
          field: 'customerRefNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.portAgent'),
          colId: 'portAgent',
          field: 'portAgent',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.forwardingAgent'),
          colId: 'forwardingAgent',
          field: 'forwardingAgent',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'),
          colId: 'designationAgent',
          field: 'designationAgent',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNos',
          field: 'containerNos',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          colId: 'customsBroker',
          field: 'customsBroker',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          colId: 'carryingCmp',
          field: 'carryingCmp',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.data.carryingCmp), 'chineseName')
            }
            return ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          colId: 'warehouseCmp',
          field: 'warehouseCmp',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.loadingPlaceCompany'),
          colId: 'loadingPlaceCompany',
          field: 'loadingPlaceCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.signBillPlaceCompany'),
          colId: 'signBillPlaceCompany',
          field: 'signBillPlaceCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.dischargePortCompany'),
          colId: 'dischargePortCompany',
          field: 'dischargePortCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.destinationPortCompany'),
          colId: 'destinationPortCompany',
          field: 'destinationPortCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          colId: 'quantityContract',
          field: 'quantityContract',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          colId: 'weightContract',
          field: 'weightContract',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          colId: 'cubageContract',
          field: 'cubageContract',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          colId: 'quantityActual',
          field: 'quantityActual',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          colId: 'weightActual',
          field: 'weightActual',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          colId: 'cubageActual',
          field: 'cubageActual',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          colId: 'chargeWeight',
          field: 'chargeWeight',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('RailwayExport.containerLoadType'),
          colId: 'containerLoadType',
          field: 'containerLoadType',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 75
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          colId: 'cargoSource',
          field: 'cargoSource',
          hide: true,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.LocalService'),
          colId: 'loadingTerm',
          field: 'loadingTerm',
          hide: true,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.loadingTermLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          colId: 'poNo',
          field: 'poNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          colId: 'containerDesc',
          field: 'containerDesc',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerNo') + '-' + this.$t('SeaExport.SealNo'),
          colId: 'tmpContainerNo',
          field: 'tmpContainerNo',
          enableRowGroup: true,
          hide: true,
          valueGetter: params => {
            if (params.data) {
              const lines = params.data.tmpContainerNo.split(',')
              let label = ''
              for (const line of lines) {
                if (!line || line.startsWith('-') || line.endsWith('-')) {
                  continue
                }
                if (label) {
                  label += ','
                }
                label += line
              }
              return label
            } else {
              return ''
            }
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          colId: 'sopState',
          field: 'sopState',
          enableRowGroup: true,
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('SeaExport.TEU'),
          colId: 'teu',
          field: 'teu',
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          colId: 'op',
          field: 'op',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          colId: 'sales',
          field: 'sales',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          colId: 'csr',
          field: 'csr',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.overseaOp'),
          colId: 'overseaOp',
          field: 'overseaOp',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.planner'),
          colId: 'planner',
          field: 'planner',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCreator'),
          colId: 'createdBy',
          field: 'createdBy',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.createdBy), 'chineseName')
            }
            return ''
          },
          width: 75
        }, {
          headerName: this.$t('SeaExport.Accrued'),
          colId: 'provisioned',
          field: 'provisioned',
          hide: true,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          colId: 'shutOut',
          field: 'shutOut',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PreverifyStatus'),
          field: 'preverifyState',
          colId: 'preverifyState',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.getPreverifyStateCN(Number(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Status'),
          colId: 'jobState',
          field: 'jobState',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.getJobStateForBlock(params.data)
            }
            return ''
          },
          filter: false,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLConsignee'),
          colId: 'hBLConsignee',
          field: 'hBLConsignee',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLShipper'),
          colId: 'shipperCode',
          field: 'shipperCode',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          colId: 'cargoType',
          field: 'cargoType',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          colId: 'customJobType',
          field: 'customJobType',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationTips'),
          colId: 'operationTips',
          field: 'operationTips',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remarks',
          field: 'remarks',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          colId: 'userDefinedField1',
          field: 'userDefinedField1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          colId: 'userDefinedField2',
          field: 'userDefinedField2',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          colId: 'userDefinedField3',
          field: 'userDefinedField3',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          colId: 'cargoChineseName',
          field: 'cargoChineseName',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'cargoEnglishName',
          field: 'cargoEnglishName',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          colId: 'shipperLine1',
          field: 'shipperLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.NotifyParty'),
          colId: 'notifyLine1',
          field: 'notifyLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          colId: 'customsDate',
          field: 'customsDate',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ManageAuditStatus'),
          colId: 'manageAuditStatus',
          field: 'manageAuditStatus',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          },
          width: 110
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          colId: 'doorAddr',
          field: 'doorAddr',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.transportType'),
          colId: 'transportType',
          field: 'transportType',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.transportTypeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.ATD2'),
          colId: 'atd',
          field: 'atd',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.ATA2'),
          colId: 'ata',
          field: 'ata',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Documents'),
          colId: 'dc',
          field: 'dc',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: 'receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: 'payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          field: 'payableChargeLockedPerson',
          colId: 'payableChargeLockedPerson',
          hide: true,
          enableRowGroup: true,
          width: 150,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnModule'),
          field: 'returnType',
          colId: 'returnType',
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          },
          valueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnReason'),
          field: 'returnRemark',
          colId: 'returnRemark',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditUser'),
          field: 'fcAuditUser',
          colId: 'fcAuditUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditDate'),
          field: 'fcAuditDate',
          colId: 'fcAuditDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.plannerDepartment'),
          field: 'plannerDepartment',
          colId: 'plannerDepartment',
          enableRowGroup: true,
          hide: true,
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.ContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          enableRowGroup: true,
          width: 150,
          hide: true
        }, {
          headerName: this.$t('queryJob.payablesWriteOfStatus'),
          colId: 'verifyStatePayable',
          field: 'verifyStatePayable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          hide: true,
          enableRowGroup: true,
          filter: false,
          filterParams: {},
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.chargeInputLabelFunction(params.data.receivableChargeInput)
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          enableRowGroup: true,
          hide: true,
          filter: false,
          filterParams: {},
          valueFormatter: params => {
            if (params.data) {
              return ColumnUtils.chargeInputLabelFunction(params.data.costChargeInput)
            }
          }
        }, {
          headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
          colId: 'receivableInvoiceState',
          field: 'receivableInvoiceState',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.jobBussStateLabelFunc(params.data.lob)
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateStatus'),
          colId: 'cooperateStatus',
          field: 'cooperateStatus',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cooperateStatusLabelFunc(Number(params.value))
          },
          hide: !this.useOrderCenterMode,
          width: 100, minWidth: 100
        },
        {
          headerName: this.$t('queryJob.EstimatedReviewer'),
          field: 'preverifier',
          colId: 'preVerifier',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('queryJob.DateOfPreReview'),
          field: 'preverifyDate',
          colId: 'preVerifyDate',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Partners.Refuser'),
          colId: 'refuser',
          field: 'refuser',
          enableRowGroup: true,
          hide: true,
          width: 180,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.refuser, 'chineseName') : ''
          },
          valueGetter: (params) => {
            if (params.data) {
              return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.refuser, 'chineseName') : ''
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'bookingRefuseNote',
          field: 'bookingRefuseNote',
          enableRowGroup: true,
          hide: true,
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? params.data.bookingRefuseNote : ''
          },
          valueGetter: (params) => {
            if (params.data) {
              return params.data.preverifyState === 3 ? params.data.bookingRefuseNote : ''
            }
            return ''
          }
        },
        {
          headerName: this.$t('Partners.RefuseDate'),
          colId: 'refuseDate',
          field: 'refuseDate',
          enableRowGroup: true,
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.data.refuseDate) : ''
          },
          valueGetter: (params) => {
            if (params.data) {
              return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.data.refuseDate) : ''
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'userDefinedField4', width: 180, hide: true, enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          colId: 'channelNo',
          enableRowGroup: true,
          hide: true,
          width: 100
        },
        { headerName: this.$t('SeaExport.MethodOfPayment'),
          field: 'paymentMethod',
          width: 180,
          colId: 'paymentMethod',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.paymentMethodLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          width: 200
        }
      ],
      rowData: [],
      gridApi: null,
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      documentManage: new DocumentManage(),
      templateSelectorDialog: {
        visible: false,
        ctx: new RailwayExportJob(),
        category: '',
        data: {}
      },
      blModeList: [],
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      creditRestrictionForBooking: 0, // 是否开启预审信控配置(0-不限制，1-弹窗确认，2-强制拦截)
      isPretrialReview: false,
      btn: {
        pretrialReviewThroughRole: false,
        pretrialReviewConfig: false,
        // 按钮权限
        btReject: true, // 拒绝
        btVerifyReviewThrough: true, // 复核通过
        btVerifyReviewRefusal: true // 复核拒绝
      },
      rejectWindow: {
        visible: false,
        jobNo: '',
        jobList: [],
        rejectCallBack: null,
        type: 0 // 0  =  列表审核通过 1  =  在详情页面审核通过
      },
      opVerifyFrameDialog: { // 审核通过
        visible: false,
        batchPassAudit: false,
        job: null,
        jobList: [],
        result: null, // 审核通过界面所填写的值
        verifyType: 1, // 订舱预审-审核通过类型
        type: 0, // 0  =  列表审核通过 1  =  在详情页面审核通过
        submitCallBack: null
      },
      batchJobList: [], // 批量审核通过的业务列表
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      editDialog: { // 编辑
        visible: false,
        job: new RailwayExportJob().fillDefaultValue().getData()
      },
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        jobUuids: [],
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      useCheckRule: false, // 是否启用验证规则
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      isZY: false,
      dataListDragGroup: false // 是否支持数据列表拖拽分组特性
    }
  },
  computed: {
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    }
  },
  async created() {
    this.blModeList = await getSpecificBasicData(basicCacheKeys.basic_data_BlMode)
    await this.preloadBasicData()
    await this.initColumnDefs()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeJob = node.data
            if (nodeJob.jobUuid) this.selectedJob = nodeJob
            this.updateControlsState()
          }
        })
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.jobUuid) this.selectedJob = node
      this.updateControlsState()
    },
    // 批量操作按钮权限控制
    updateControlsState() {
      const _job = this.selectedJob
      if (_job) {
        this.btn.btReject = _job.jobState === -1 && (_job.preverifyState !== 5 && _job.preverifyState !== 2 && _job.preverifyState !== 3)
        this.btn.btReject = this.btn.btReject || (this.isCooperate(_job.cooperateStatus) && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(_job.cooperateStatus))
        if (this.btn.pretrialReviewConfig) {
          // 选中的所有job，判断是否全部符合复核条件
          let btVerifyReviewThroughs = true
          const jobLists = this.readSelectedRows(false)
          for (let i = 0; i < jobLists.length; i++) {
            const job = jobLists[i]
            if (!(job.jobState === -1 && job.preverifyState === 2)) {
              btVerifyReviewThroughs = false
            }
          }
          // 复核通过
          this.btn.btVerifyReviewThrough = btVerifyReviewThroughs
          // 复核拒绝
          this.btn.btVerifyReviewRefusal = _job.jobState === -1 && _job.preverifyState === 2
        }
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.init()
    },
    init() {
      this.btn.pretrialReviewThroughRole = this.$checkPermission(['button_reVerify_reviewThrough'])
      this.btn.pretrialReviewConfig = parseInt(cache.config.get('PretrialReviewRailway')) === 1
      this.creditRestrictionForBooking = parseInt(cache.config.get('CreditRestrictionForBooking'))
      this.isPretrialReview = Number(cache.config.get('PretrialReviewRailway')) === 1
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(cache.config.get('allowPartialCheckPass')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    },
    // 组装查询条件
    getCustomSearchItems() {
      const dataProvider = Array.from(SystemConstants.VERIFY_STATES)
      if (this.isPretrialReview) {
        dataProvider.push(SystemConstants.VERIFYING_REVIEW_THROUGH)
        dataProvider.push(SystemConstants.VERIFYING_REVIEW_REFUSAL)
      }
      const defaultSearchFields = []
      // 预审状态
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.PREVERIFY_STATE'
      searchField.itemLabel = 'SeaExport.PreverifyStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_SystemConstants$VERIFY_STATES'
      searchField.dataCacheKey = ''
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = dataProvider
      defaultSearchFields.push(searchField.formatObj2Json())
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
        // 协作状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.COOPERATE_STATUS'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = Array.from(SystemConstants.COOPERATE_STATUS)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 箱型
      const boxTypes = RailwayExportConstants.RAILWAY_EXPORT_BOX_TYPES.map(item => {
        return { code: item.code, chineseName: item.chineseName, englishName: item.englishName }
      })

      defaultSearchFields.push(JobUtils.createSearchField(boxTypes, 'seaEq.EQSIZE', 'SeaExport.BoxModel'))

      // 箱种
      const eqTypes = getCacheListByKey(TYPE_NAMES.basic_data_EQType)
      const eqTypeList = eqTypes && Array.isArray(eqTypes)
        ? eqTypes.map((eqType) => ({
          code: eqType.code,
          chineseName: eqType.code,
          englishName: eqType.name
        })) : []

      defaultSearchFields.push(JobUtils.createSearchField(eqTypeList, 'seaEq.EQTYPE', 'SeaExport.BoxSpecies'))
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
      // 自定义业务类型
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'cutomJobType'
      searchField.subType = 'RE'
      searchField.fieldType = 'FIELD_CUTOM_JOB_TYPE_RE'
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'job.CUSTOM_JOB_TYPE'
      searchField.itemLabel = 'queryJob.customJobType'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = 'uuid'
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && mapping.railwayFreight === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 运输类型
      const transportationTypes = getCacheListByKey(TYPE_NAMES.basic_data_TransportationType)
      const transportationTypeList = transportationTypes && Array.isArray(transportationTypes) ? transportationTypes.map((transportationType) => ({
        code: transportationType.code,
        chineseName: transportationType.chineseName,
        englishName: transportationType.englishName
      })) : []
      defaultSearchFields.push(JobUtils.createSearchField(transportationTypeList, 'reJob.TRANSPORT_TYPE', 'SeaExport.TransportType'))
      // 付款方式
      const paymentMethods = getCacheListByKey(TYPE_NAMES.basic_data_PaymentMethod)
      const paymentMethodList = paymentMethods && Array.isArray(paymentMethods) ? paymentMethods.map((paymentMethod) => ({
        code: paymentMethod.code,
        chineseName: paymentMethod.chineseName,
        englishName: paymentMethod.englishName
      })) : []
      defaultSearchFields.push(JobUtils.createSearchField(paymentMethodList, 'reJob.PAYMENT_METHOD', 'Clearing.PaymentMethod'))
      return defaultSearchFields
    },
    async initColumnDefs() {
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(params.value)
            }
          }
        )
      }
    },
    // 查询[简单查询/高级查询]
    toQuery(workSpaceRowData) {
      if (workSpaceRowData && workSpaceRowData.length > 0) {
        this.toBackQuery(workSpaceRowData)
        return
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      if (!this.filterJson.conditions) return
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.requires = ['railwayBookingVerify']
      this.filterJson.verifyModel = true
      this.loading = getLoading()
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.notRefresh = false
        this.loading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      const lcOption = AdvancedSearchOption.removeOption('job.localSevice', data)
      if (lcOption) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
          if (service) {
            services.push(service)
          }
        }
        const stuffingTypes = this.filterStuffingType(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('job.CUSTOM_JOB_TYPE', data)) {
        const option = AdvancedSearchOption.removeOption('job.CUSTOM_JOB_TYPE', data)
        const customJobType = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'uuid', option.value)
        if (customJobType) {
          option.value = [customJobType.type, customJobType.code]
        }
        // 重新加入
        data.push(option)
      }
      // 预审
      if (!AdvancedSearchOption.hasField('job.PREVERIFY_STATE', data)) {
        data.push(new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', [0, 1, 2, 3], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        data.push(new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json())
      }
      return data
    },
    filterStuffingType(items) {
      if (items.length > 0) {
        if (items.length > 1 && this.isSelfDeliveryExits(items)) {
          // 如果存在自拉自送则删除内装箱和门点装箱
          for (let i = items.length - 1; i >= 0; --i) {
            const stuffyType = items[i]
            if (stuffyType.code === 'IS' || stuffyType.code === 'DD') {
              items.splice(i, 1)
            }
          }
        }
        return this.convertStuffyTypeToQuery(items)
      }
      return []
    },
    isSelfDeliveryExits(items) {
      for (const stuffyType of items) {
        if (stuffyType.code === 'SD') {
          return true
        }
      }
      return false
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.WAREHOUSING')
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'CT') {
          result.push('reJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('reJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('reJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      if (!this.filter.jobNo) return
      this.loading = getLoading()
      advancedQuery({
        conditions: [
          new AdvancedSearchOption(null, 'job.JOB_NO', this.filter.jobNo, 'LIKE').formatObj2Json(),
          new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json()
        ],
        requires: ['railwayBookingVerify'],
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        verifyModel: true
      }).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 返回查询
    toBackQuery(jobs) {
      const conditions = []
      if (jobs && jobs.length > 0) {
        const jobNos = Array.from(jobs, p => p.jobNo)
        conditions.push(new AdvancedSearchOption(null, 'job.JOB_NO', jobNos, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
      }
      conditions.push(new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json())
      this.filterJson.conditions = conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.requires = ['railwayBookingVerify']
      const loading = getLoading()
      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.rowData = res.data.list
      this.selectedJob = null
      this.selectedRowCount = 0
      this.updateControlsState()
      this.gridApi.clearFocusedCell()
    },
    // 查看
    toLook(row) {
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      this.$emit('look', row)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 审核通过：0 批量审核通过 1 在详情页面审核通过
    acceptHandler(type) {
      this.opVerifyFrameDialog.type = type
      if (type === 0) {
        const jobLists = this.readSelectedRows()
        if (!jobLists || jobLists.length <= 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJob'))
          return
        }
        if (jobLists.length > 50) {
          this.$message.warning(this.$t('SeaExport.BatchAuditBusinessTip'))
          return
        }
        // 协作状态: 审核通过
        const cooperateList = []
        for (const seaJob of jobLists) {
          if (this.isCooperate(seaJob.cooperateStatus)) { cooperateList.push(seaJob.uuid) }
        }
        if (cooperateList.length > 0) {
          if (cooperateList.length !== jobLists.length) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CooperateReviewSeparately'))
            return
          }
          this.acceptCooperateHandler(type, cooperateList)
          return
        }
        const jobArr = []
        for (const seaJob of jobLists) {
          if (seaJob.jobState !== -1 || seaJob.preverifyState === 2 || seaJob.preverifyState === 3) {
            jobArr.push(seaJob.jobNo)
          }
          if (this.isPretrialReview && (seaJob.preverifyState === 5 || seaJob.preverifyState === 6)) {
            jobArr.push(seaJob.jobNo)
          }
        }
        if (jobArr.length > 0) {
          const str = this.isPretrialReview ? `${this.$t('Message.Approved')}/${this.$t('CargoMsg.Cargo_Denied')}/${this.$t('SeaExport.VerifyReviewThrough')}/${this.$t('SeaExport.ReviewRejectedBusinessNumber')}` : `${this.$t('Message.Approved')}/${this.$t('SeaExport.RejectedBusinessNumber')}`
          const h = this.$createElement
          const content = h('div', null, [
            h('p', { style: 'overflow-wrap: break-word;' }, jobArr.join(','))
          ])
          this.$alert(content, str)
          return
        }

        this.opVerifyFrameDialog.batchPassAudit = jobLists.length > 1
        this.opVerifyFrameDialog.job = jobLists[0]
        this.opVerifyFrameDialog.jobList = jobLists
      } else {
        if (this.isCooperate(this.selectedJob.cooperateStatus)) {
          this.acceptCooperateHandler(type, [this.selectedJob.uuid])
          return
        }
        this.opVerifyFrameDialog.batchPassAudit = false
        this.opVerifyFrameDialog.job = this.selectedJob
        const jobLists = []
        jobLists.push(this.selectedJob)
        this.opVerifyFrameDialog.jobList = jobLists
      }

      this.opVerifyFrameDialog.submitCallBack = this.acceptSubmitCallBack
      this.opVerifyFrameDialog.visible = true
    },
    acceptSubmitCallBack(result) {
      this.batchJobList = []
      this.opVerifyFrameDialog.result = result
      if (this.opVerifyFrameDialog.jobList.length === 1) {
        this.batchJobList.push(this.opVerifyFrameDialog.job)
      } else {
        // 信控数据校验
        this.batchJobList = this.opVerifyFrameDialog.jobList
      }
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      const callBack = () => { batchCheckJobsCredit(jobKeys).then(res => this.checkCreditResultHandler(res)) }
      // 判断是否开启验证规则
      if (this.useCheckRule) {
        const checkNode = CheckRuleConstants.NODE_BOOKING_VERIFY.code
        // const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, 'RE')
        const hasCheckRule = true
        if (hasCheckRule) {
          this.batchCheckingWindow.jobs = this.batchJobList
          if (this.allowPartialCheckPass) {
            this.checkingManager(this.batchJobList, checkNode, callBack, null, true, result)
          } else {
            this.checkingManager(this.batchJobList, checkNode, callBack, null, false, result)
          }
        } else {
          callBack()
        }
      } else {
        callBack()
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    batchAudit() {
      // 订舱预审-审核通过类型1、save2 2、approved2 3、batchUpdateJobs 4、batchApproved
      let verifyType = 0 // 以下接口统一放在后端区分了
      if (this.batchJobList.length === 1) {
        if (this.btn.pretrialReviewConfig && this.btn.pretrialReviewThroughRole) {
          verifyType = 1
        } else {
          verifyType = 2
        }
      }
      if (verifyType === 0) {
        if (this.btn.pretrialReviewConfig && this.btn.pretrialReviewThroughRole) {
          verifyType = 3
        } else {
          verifyType = 4
        }
      }
      const result = this.opVerifyFrameDialog.result
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      if (result) {
        result.jobKeys = jobKeys
        result.verifyType = this.opVerifyFrameDialog.verifyType = verifyType
        result.jobState = 0
        result.preverifyState = 2
      }
      this.loading = getLoading()
      approved(result, this.$store.getters.currentOfficeId).then(res => this.approvedResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    approvedResultHandler(res) {
      if (res && res.data) Object.assign(this.opVerifyFrameDialog.job, res.data)
      const verifyType = this.opVerifyFrameDialog.verifyType
      switch (verifyType) {
        case 1:
        case 2:
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          if (this.opVerifyFrameDialog.type === 1) { // 详情审核通过
            this.$emit('refresh', this.opVerifyFrameDialog.job)
          } else {
            this.reloadFunc()
          }
          break
        case 3:
        case 4:
          this.$message.success(this.$t('SeaExport.BatchAuditSuccess'))
          this.reloadFunc()
          break
        default:
          break
      }
    },
    // 拒绝 0 列表 1 详情
    rejectHandler(type) {
      this.rejectWindow.type = type
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      // 协作业务不支持批量拒绝
      if (jobs.length > 1) {
        for (const job of jobs) {
          if (this.isCooperate(job.cooperateStatus)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CollabBatchRejectError', [job.jobNo]))
            return
          }
        }
      }
      let rejectCallBack = this.rejectCallBackHandler
      if (jobs.length === 1) {
        const job = jobs[0]
        if (this.isCooperate(job.cooperateStatus)) {
          rejectCallBack = this.rejectCooperateCallBackHandler
        }
      }
      this.rejectWindow.jobNo = this.selectedJob ? this.selectedJob.jobNo : ''
      this.rejectWindow.jobList = jobs
      this.rejectWindow.rejectCallBack = rejectCallBack
      this.rejectWindow.visible = true
    },
    rejectCallBackHandler(remark) {
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        return
      }
      const jobKeys = Array.from(jobs, p => p.uuid)
      this.loading = getLoading()
      batchPreVerifyReject({ 'jobKey': jobKeys, 'remark': remark, 'preverifyState': 3 }).then(res => this.preVerifyRejectResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    preVerifyRejectResultHandler(res) {
      this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      this.toQuery()
      this.selectedJob = null
      this.updateControlsState()
      this.gridApi.clearFocusedCell()
    },
    // 复核通过
    btVerifyReviewThroughHandler(type) {
      if (type === 0) {
        // 列表批量复核
        const jobLists = this.readSelectedRows()
        if (!jobLists || jobLists.length <= 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJob'))
          return
        }
        if (jobLists.length > 50) {
          this.$message.warning(this.$t('SeaExport.CheckBatchReview'))
          return
        }
        const jobNos = []
        for (const job of jobLists) {
          if (this.isCooperate(job.cooperateStatus)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
            return
          }
          if (!(parseInt(job.jobState) === -1 && parseInt(job.preverifyState) === 2)) {
            jobNos.push(job.jobNo)
          }
        }
        if (jobNos.length > 0) {
          const h = this.$createElement
          const content = h('div', null, [
            h('p', { style: 'overflow-wrap: break-word;' }, jobNos.join(','))
          ])
          this.$alert(content, this.$t('SeaExport.UnreviewedBusinessNumber2'))
          return
        }
        const jobKeys = Array.from(jobLists, p => p.uuid)
        const result = {}
        result.jobKeys = jobKeys
        result.verifyType = 6
        result.jobState = 0
        result.preverifyState = 5
        this.loading = getLoading()
        approved(result, this.$store.getters.currentOfficeId).then(res => {
          this.$message.success(this.$t('SeaExport.BatchReviewSuccess'))
          this.reloadFunc()
        }).finally(() => {
          this.loading.close()
        })
      } else {
        if (this.isCooperate(this.selectedJob.cooperateStatus)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
          return
        }
        // 详情单个复核
        const result = {}
        result.jobKeys = [this.selectedJob.uuid]
        result.verifyType = 5
        result.jobState = 0
        result.preverifyState = 5
        this.loading = getLoading()
        approved(result, this.$store.getters.currentOfficeId).then(res => {
          Object.assign(this.selectedJob, res.data)
          this.$message.success(this.$t('SeaExport.ReviewSuccess'))
          this.$emit('refresh', this.selectedJob)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 复核拒绝
    btVerifyReviewRefusalHandler(type) {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (this.isCooperate(this.selectedJob.cooperateStatus)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
        return
      }
      this.loading = getLoading()
      preVerifyReject(this.selectedJob.uuid, '', 6).then(res => {
        if (res && res.data) Object.assign(this.selectedJob, res.data)
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        if (type === 1) { // 详情审核通过
          this.$emit('refresh', this.selectedJob)
        } else {
          this.reloadFunc()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    reloadFunc() {
      this.toQuery()
      this.selectedJob = null
      this.updateControlsState()
      this.gridApi.clearFocusedCell()
    },
    // 编辑
    async toEdit() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.$emit('edit', this.selectedJob)
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 复制
    copyJobHandler() {
      if (!this.selectedJob) {
        this.$message.info(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.selectedJob)
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new RailwayExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false, newJob = null) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.newJob = newJob
        this.batchCheckingWindow.visible = true
      }
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    // 是否协作状态
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        return true
      }
      return false
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(type, cooperateList) {
      if (!cooperateList || cooperateList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuids = cooperateList
      this.cooperationVerifyDialog.jobUuid = this.selectedJob.uuid // 显示其中一笔
      const cooperate = {
        branchId: this.selectedJob.cooperateBranchId,
        opId: this.selectedJob.cooperateOpId,
        csrId: this.selectedJob.cooperateCsrId,
        overseaOp: this.selectedJob.cooperateOverseaOp,
        dcId: this.selectedJob.cooperateDcId,
        planner: this.selectedJob.cooperatePlanner,
        sales: this.selectedJob.cooperateSales,
        cargoSalesId: this.selectedJob.cooperateCargoSalesId,
        userDefinedRoleId1: this.selectedJob.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.selectedJob.cooperateUserDefinedRoleId2,
        businessType: this.selectedJob.cooperateBusinessTypeCode ? this.selectedJob.cooperateBusinessTypeCode.split(',') : []
      }
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuids: this.cooperationVerifyDialog.jobUuids, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.reloadFunc()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.selectedJob.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.reloadFunc()
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>
